export enum ConversationToolType {
  meeting = 'meeting',
  meetingV2 = 'meeting-form',
  conversationMeeting = 'conversation-meeting',
  data = 'data',
  rocks = 'rocks',
  todos = 'todos',
  issues = 'issues',
  vto = 'vision',
  ac = 'chart',
  directory = 'directory',
}
